// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isString = (value: any) => Object.prototype.toString.call(value) === '[object String]';

export default isString;
